import { isSupportedConfirmWindowInbound } from '../../api/inbound/commonInbounds/showConfirmWindowInbound';
import { createGiveJacksOutbound } from '../../api/outbound/commonOutbounds';
import { CHANGE_EMAIL_TOAST_KEY, CHANGE_PASSWORD_TOAST_KEY } from '../../types/toastTypes';
import { getHtmlTextContent } from '../../utils/htmlUtils';
import { setGameEntryActionPending } from './gameEntryActions';
import { thunkCloseToast } from './toastsActions';
export const CLEAR_MESSAGE_BOXES_STATE = 'CLEAR_MESSAGE_BOXES_STATE';
export const ADD_MESSAGE_BOX = 'ADD_MESSAGE_BOX';
export const ADD_MESSAGE_BOX_FROM_INBOUND = 'ADD_MESSAGE_BOX_FROM_INBOUND';
export const CLOSE_CURRENT_MESSAGE_BOX = 'CLOSE_CURRENT_MESSAGE_BOX';
export function clearMessageBoxesState() {
    return {
        type: CLEAR_MESSAGE_BOXES_STATE
    };
}
export function addMessageBox(messageBox) {
    return {
        type: ADD_MESSAGE_BOX,
        payload: messageBox
    };
}
function addMessageBoxFromInbound(inbound) {
    return {
        type: ADD_MESSAGE_BOX_FROM_INBOUND,
        payload: inbound
    };
}
export const thunkAddMessageBoxFromInbound = (inbound) => {
    return function (dispatch) {
        // TODO: Update server to not send options HTML message boxes to this client.
        const ignoredLegacyMovieClipLabels = [
            'options' // options (or "player settings") are handled by initializing redux with the provided settings at lobby- or room-enter time, then updating in response to option: inbounds
        ];
        if (ignoredLegacyMovieClipLabels.includes(inbound.legacyFlashMovieClipLabel)) {
            console.warn(`Ignoring message box inbound with legacy movie clip label '${inbound.legacyFlashMovieClipLabel}'`);
            return;
        }
        dispatch(addMessageBoxFromInbound(inbound));
    };
};
function closeCurrentMessageBox() {
    return {
        type: CLOSE_CURRENT_MESSAGE_BOX
    };
}
export const thunkCloseCurrentMessageBox = () => {
    return function (dispatch, getState) {
        const state = getState();
        /**
         * Determine if this message box has a related toast key, and if so, close any open toast that matches when the message box is closed:
         */
        function maybeCloseRelatedToasts() {
            const currentMessageBox = state.messageBoxes.messageBoxes.length && state.messageBoxes.messageBoxes[0];
            if (currentMessageBox && 'toastKey' in currentMessageBox && currentMessageBox.toastKey) {
                dispatch(thunkCloseToast(currentMessageBox.toastKey));
            }
        }
        maybeCloseRelatedToasts();
        dispatch(closeCurrentMessageBox());
    };
};
export function showPowerPlayerUpgradeMessageBoxFromInbound(inbound) {
    return addMessageBox({
        type: 'power-player-status',
        isPowerPlayer: inbound.isPowerPlayer,
        expirationDateString: inbound.expirationDateString,
        allowUpgradeHere: inbound.allowUpgradeHere,
        powerPlayerProducts: inbound.powerPlayerProducts
    });
}
export const showChangePasswordMessageBox = () => {
    return function (dispatch, getState) {
        const username = getState().selfData.username;
        dispatch(addMessageBox({
            type: 'change-password',
            title: `Change Password${username ? ` for ${username}` : ''}`,
            toastKey: CHANGE_PASSWORD_TOAST_KEY
        }));
    };
};
export const showChangeEmailMessageBox = (currentEmail) => {
    return function (dispatch) {
        dispatch(addMessageBox({
            type: 'change-email',
            currentEmail,
            toastKey: CHANGE_EMAIL_TOAST_KEY
        }));
    };
};
export const showConfirmWindowMessageBoxFromInbound = (inbound) => {
    return function (dispatch) {
        if (!isSupportedConfirmWindowInbound(inbound)) {
            console.warn('Confirm window type is not currently supported and was ignored', inbound);
            return;
        }
        dispatch(addMessageBox({
            type: 'confirm',
            title: inbound.title,
            message: inbound.messageHtml,
            isHtmlMessage: true,
            showCloseButton: inbound.showCloseButton,
            buttons: inbound.buttons
        }));
    };
};
export function showConfirmMessageBox(title, message, showCloseButton, buttons) {
    return addMessageBox({
        type: 'confirm',
        title,
        message,
        isHtmlMessage: false,
        showCloseButton,
        buttons
    });
}
export function showTourneyCalendarMessageBox() {
    return addMessageBox({ type: 'tourney-calendar' });
}
export function showGiveChipsMessageBoxFromInbound(inbound) {
    const { toPlayer, minChips, maxChips, taxCurrencyPercent, untaxedChipsGivenMonthly, jacksCost } = inbound;
    return addMessageBox({
        type: 'give-chips',
        toPlayer,
        minChips,
        maxChips,
        taxCurrencyPercent,
        untaxedChipsGivenMonthly,
        jacksCost
    });
}
export function showGiveJacksMessageBox(toPlayer) {
    return addMessageBox({ type: 'give-jacks', toPlayer });
}
export const showJacksWindowMessageBoxFromInbound = (inbound) => {
    return function (dispatch) {
        switch (inbound.page) {
            case 'give_confirm': {
                const { giveConfirmNumJacks, giveConfirmNumJacksRequired, giveConfirmToUsername, numFreeJacksGivenMonthly, taxPercent } = inbound;
                const message = [
                    `Give ${giveConfirmNumJacks.toLocaleString()} Jack${giveConfirmNumJacks !== 1 ? 's' : ''} to ${giveConfirmToUsername}?`
                ];
                if (giveConfirmNumJacksRequired > giveConfirmNumJacks) {
                    message.push(`(Every player is allowed to transfer ${numFreeJacksGivenMonthly.toLocaleString()} Jacks each month. Your transfer exceeds this, so a ${taxPercent}% tax will be applied and ${giveConfirmNumJacksRequired.toLocaleString()} Jacks will be deducted from your account.)`);
                }
                dispatch(addMessageBox({
                    type: 'confirm',
                    title: 'Confirm Jacks Transfer',
                    message,
                    isHtmlMessage: false,
                    showCloseButton: true,
                    buttons: [
                        {
                            label: 'Yes, Give Jacks',
                            actions: [
                                {
                                    type: 'outbound',
                                    outbound: createGiveJacksOutbound(giveConfirmToUsername, giveConfirmNumJacks, true)
                                }
                            ],
                            closeAfterClick: true
                        },
                        {
                            label: 'Cancel',
                            actions: [],
                            closeAfterClick: true
                        }
                    ]
                }));
                break;
            }
            default: {
                console.warn(`Jacks window page '${inbound.page}' is not handled`);
            }
        }
    };
};
export function showSettingsMessageBox() {
    return addMessageBox({ type: 'settings' });
}
export const showSignUpErrorMessageBoxFromInbound = (inbound) => {
    return function (dispatch) {
        dispatch(setGameEntryActionPending(false));
        dispatch(addMessageBox({
            type: 'inbound',
            title: getHtmlTextContent(inbound.errorHtml) || 'Sign Up Error'
        }));
    };
};
export const showLoginErrorMessageBoxFromInbound = (inbound) => {
    return function (dispatch) {
        dispatch(setGameEntryActionPending(false));
        dispatch(addMessageBox({
            type: 'inbound',
            title: getHtmlTextContent(inbound.errorHtml) || 'Login Error'
        }));
    };
};
export function showPlayerDebugInfoMessageBoxFromInbound(inbound) {
    return addMessageBox({ type: 'record', title: `${inbound.playerIdName.name} Debug Info`, fields: inbound.fields });
}
export const showNewestPlayersListMessageBoxFromInbound = (inbound) => {
    return function (dispatch) {
        const headers = ['Player', 'Date'];
        const rows = inbound.newestPlayers.map((newestPlayer) => {
            return {
                cellValues: [newestPlayer.playerIdName.name, { value: newestPlayer.signUpTimeStr, style: { fontSize: '75%' } }],
                clickAction: {
                    type: 'show-player-info',
                    player: newestPlayer.playerIdName
                }
            };
        });
        dispatch(addMessageBox({
            type: 'table',
            title: 'Newest Players',
            description: 'These are the newest players to Triplejack! Please extend a warm welcome to them, and help them get up to speed with the game and our community!',
            headers,
            rows,
            maxWidth: 'sm'
        }));
    };
};
export const showAdminNewestPlayersListMessageBoxFromInbound = (inbound) => {
    return function (dispatch) {
        const headers = ['Player', 'Status', 'Hands Played', 'Time (CST)'];
        function getStatus(newestPlayer) {
            const statuses = [];
            if (!newestPlayer.isEnabled) {
                statuses.push('Disabled');
            }
            if (!newestPlayer.isVerified) {
                statuses.push('Unverified');
            }
            return statuses.length ? statuses.join(', ') : '';
        }
        const rows = inbound.newestPlayers.map((newestPlayer) => {
            return {
                cellValues: [
                    newestPlayer.playerIdName.name,
                    getStatus(newestPlayer),
                    { value: newestPlayer.numHandsPlayed.toLocaleString(), style: { textAlign: 'right' } },
                    { value: newestPlayer.signUpTimeStr, style: { fontSize: '75%' } }
                ],
                clickAction: {
                    type: 'show-player-info',
                    player: newestPlayer.playerIdName
                }
            };
        });
        dispatch(addMessageBox({
            type: 'table',
            title: 'Newest Players (Admin View)',
            headers,
            rows,
            maxWidth: 'md'
        }));
    };
};
export const showRecentAdminActionsMessageBoxFromInbound = (inbound) => {
    return function (dispatch) {
        const headers = ['Player', 'Action', 'Notes', 'Admin', 'Time (CST)'];
        const rows = inbound.actions.map((action) => ({
            cellValues: [
                action.targetPlayer.name,
                action.actionStr,
                {
                    value: action.memo,
                    style: { whiteSpace: 'pre-wrap' }
                },
                action.adminPlayer.name,
                { value: action.dateStr, style: { fontSize: '75%' } }
            ],
            clickAction: {
                type: 'show-player-info',
                player: action.targetPlayer
            }
        }));
        dispatch(addMessageBox({
            type: 'table',
            title: 'Recent Admin Actions',
            headers,
            rows,
            maxWidth: 'xl'
        }));
    };
};
export const showTourneySummaryMessageBoxFromInbound = (inbound) => {
    return function (dispatch) {
        dispatch(addMessageBox({
            type: 'tourney-summary',
            // TODO: Reconsider this if level tourneys are a thing, because the title will include the username in that case and may look odd.
            // Keep in mind that in a level tourney, if the level-up player loses, the title from the server will not mention the winner.
            title: `Winner: ${inbound.winnerName}`,
            html: inbound.summaryHtml,
            winnerName: inbound.winnerName,
            shareWinMessage: inbound.shareWinMessage
        }));
    };
};
export function thunkShowUpcomingTourneysMessageBoxFromInbound(inbound) {
    return function (dispatch, getState) {
        const state = getState();
        if (state.messageBoxes.messageBoxes.length && state.messageBoxes.messageBoxes[0].type === 'upcoming-tourneys') {
            // upcoming tourneys modal is already up, so close it and replace with updated info
            dispatch(closeCurrentMessageBox());
        }
        dispatch(addMessageBox({ type: 'upcoming-tourneys', upcomingTourneys: inbound.tourneys }));
    };
}
export const showTestEmailLogMessageBoxFromInbound = (inbound) => {
    return function (dispatch) {
        const headers = ['To', 'Subject'];
        const rows = inbound.emailMessages.map((emailMessage) => ({
            cellValues: [emailMessage.to.join(', '), emailMessage.subject],
            clickAction: {
                type: 'show-test-email-details',
                emailMessage: emailMessage
            }
        }));
        dispatch(addMessageBox({
            type: 'table',
            title: 'Test Email Log',
            headers,
            rows,
            maxWidth: 'xl'
        }));
    };
};
